import {
  NgModule,
} from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import {
  BookingPageId,
  BookingRouteParams,
  BookingRoutes,
  ManageBookingRoutes,
  RebookingRoutes,
  RewardPageId,
  RewardRoutes,
  RoutesTitle,
} from '../configuration/routes';
import {
  AppGuard,
} from './app.guard';

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [AppGuard],
    children: [
      {
        path: '',
        redirectTo: `/${BookingRoutes.upsell}`,
        runGuardsAndResolvers: 'always',
        pathMatch: 'full'
      },
      {
        path: RewardRoutes.upsell,
        loadChildren: () => import('./booking/upsell/upsell.module').then((m) => m.UpsellModule),
        data: {
          title: RoutesTitle.rewardUpsell,
          id: RewardPageId.upsell,
          entryPoint: true
        }
      },
      {
        path: RewardRoutes.retrieve,
        loadChildren: () => import('./manage-booking/retrieve/index').then((m) => m.RetrieveModule),
        runGuardsAndResolvers: 'always',
        data: {
          title: RoutesTitle.rewardRetrieve,
          id: RewardPageId.retrieve,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.upsell,
        loadChildren: () => import('./booking/upsell/upsell.module').then((m) => m.UpsellModule),
        data: {
          title: RoutesTitle.upsell,
          id: BookingPageId.upsell,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.upsellComplexFlow,
        loadChildren: () => import('./booking/upsell-complex-flow/upsell-complex-flow.module').then((m) => m.UpsellComplexFlowModule),
        runGuardsAndResolvers: 'always',
        data: {
          title: RoutesTitle.upsellComplexFlow,
          id: BookingPageId.upsellComplexFlow,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.findMoreFlights,
        loadChildren: () => import('./booking/find-more-flights/find-more-flights.module').then((m) => m.FindMoreFlightsModule),
        data: {
          title: RoutesTitle.findMoreFlights,
          id: BookingPageId.findMoreFlights
        }
      },
      {
        path: `${BookingRoutes.dangerousGoods}`,
        loadChildren: () => import('./booking/booking-dangerous-goods/booking-dangerous-goods.module').then((m) => m.BookingDangerousGoodsModule),
        data: {
          title: RoutesTitle.dangerousGoods,
          id: BookingPageId.dangerousGoods,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.shoppingCart,
        loadChildren: () => import('./booking/shopping-cart/shopping-cart.module').then((m) => m.ShoppingCartModule),
        data: {
          title: RoutesTitle.shoppingCart,
          id: BookingPageId.shoppingCart,
          entryPoint: true
        }
      },
      {
        path: `${BookingRoutes.traveler}/:${BookingRouteParams.travelerIndex}`,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.traveler,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: `${ManageBookingRoutes.traveler}/:${BookingRouteParams.travelerIndex}`,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: ManageBookingRoutes.traveler,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: `${RebookingRoutes.traveler}/:${BookingRouteParams.travelerIndex}`,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: RebookingRoutes.traveler,
        loadChildren: () => import('./shared/traveler/traveler.module').then((m) => m.TravelerModule),
        data: {
          title: RoutesTitle.traveler,
          id: BookingPageId.traveler,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.contactInfo,
        loadChildren: () => import('./booking/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
        data: {
          title: RoutesTitle.contactInfo,
          id: BookingPageId.contactInfo
        }
      },
      {
        path: BookingRoutes.payment,
        loadChildren: () => import('./shared/payment/payment.module').then((m) => m.PaymentModule),
        data: {
          title: RoutesTitle.payment,
          id: BookingPageId.payment,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.confirmation,
        loadChildren: () => import('./shared/confirmation/confirmation.module').then((m) => m.ConfirmationModule),
        data: {
          title: RoutesTitle.confirmation,
          id: BookingPageId.confirmation,
          entryPoint: true
        }
      },
      {
        path: ManageBookingRoutes.confirmation,
        loadChildren: () => import('./shared/confirmation/confirmation.module').then((m) => m.ConfirmationModule),
        data: {
          title: RoutesTitle.manageBooking,
          id: BookingPageId.manageBooking,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.seatmap,
        loadChildren: () => import('./shared/seatmap/seatmap.module').then((m) => m.SeatmapModule),
        data: {
          title: RoutesTitle.seatmap,
          id: BookingPageId.seatmap,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.services,
        loadChildren: () => import('./shared/services/services.module').then((m) => m.ServicesModule),
        data: {
          title: RoutesTitle.services,
          id: BookingPageId.services,
          entryPoint: true
        }
      },
      {
        path: ManageBookingRoutes.retrieve,
        loadChildren: () => import('./manage-booking/retrieve/index').then((m) => m.RetrieveModule),
        data: {
          title: RoutesTitle.retrieve,
          id: BookingPageId.retrieve,
          entryPoint: true
        }
      },
      {
        path: ManageBookingRoutes.flightsUpgrade,
        loadChildren: () => import('./manage-booking/flights-upgrade-page/index').then((m) => m.FlightsUpgradePageModule),
        data: {
          title: RoutesTitle.flightsUpgrade,
          id: BookingPageId.flightsUpgrade
        }
      },
      {
        path: ManageBookingRoutes.retrieveExpiredBooking,
        loadChildren: () => import('./manage-booking/retrieve-expired-booking/index').then((m) => m.RetrieveExpiredBookingModule),
        data: {
          title: RoutesTitle.retrieveExpiredBooking,
          id: BookingPageId.retrieveExpiredBooking
        }
      },
      {
        path: ManageBookingRoutes.reviewUnpaidServices,
        loadChildren: () => import('./manage-booking/review-unpaid-services/index').then((m) => m.ReviewUnpaidServicesModule),
        data: {
          title: RoutesTitle.reviewUnpaidServices,
          id: BookingPageId.reviewUnpaidServices
        }
      },
      {
        path: ManageBookingRoutes.insurance,
        loadChildren: () => import('./shared/insurance/index').then((m) => m.InsuranceModule),
        data: {
          title: RoutesTitle.insurance,
          id: BookingPageId.insurance,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.challenge,
        loadChildren: () => import('./shared/challenge/index').then((m) => m.ChallengeModule),
        data: {
          title: RoutesTitle.challenge,
          id: BookingPageId.challenge,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.recovery,
        loadChildren: () => import('./shared/recovery/index').then((m) => m.RecoveryModule),
        data: {
          title: RoutesTitle.recovery,
          id: BookingPageId.recovery,
          entryPoint: true
        }
      },
      {
        path: RebookingRoutes.search,
        loadChildren: () => import('./rebooking/rebooking-search/index').then((m) => m.RebookingSearchModule),
        data: {
          title: RoutesTitle.rebookingSearch,
          id: BookingPageId.rebookingSearch,
          entryPoint: true
        }
      },
      {
        path: RebookingRoutes.upsell,
        loadChildren: () => import('./rebooking/rebooking-upsell/rebooking-upsell.module').then((m) => m.RebookingUpsellModule),
        data: {
          title: RoutesTitle.rebookingUpsell,
          id: BookingPageId.rebookingUpsell
        }
      },
      {
        path: RebookingRoutes.confirmation,
        loadChildren: () => import('./shared/confirmation/confirmation.module').then((m) => m.ConfirmationModule),
        data: {
          title: RoutesTitle.rebookingConfirmation,
          id: BookingPageId.rebookingConfirmation
        }
      },
      {
        path: RebookingRoutes.payment,
        loadChildren: () => import('./shared/payment/payment.module').then((m) => m.PaymentModule),
        data: {
          title: RoutesTitle.rebookingPayment,
          id: BookingPageId.rebookingPayment,
          entryPoint: true
        }
      },
      {
        path: RebookingRoutes.recap,
        loadChildren: () => import('./rebooking/rebooking-recap/index').then((m) => m.RebookingRecapModule),
        data: {
          title: RoutesTitle.rebookingRecap,
          id: BookingPageId.rebookingRecap
        }
      },
      {
        path: BookingRoutes.timetable,
        loadChildren: () => import('./booking/timetable/timetable.module').then((m) => m.TimetableModule),
        data: {
          title: RoutesTitle.timetable,
          id: BookingPageId.timetable,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.flightStatusSearch,
        loadChildren: () => import('./booking/flight-status-search/flight-status-search.module').then((m) => m.FlightStatusSearchModule),
        data: {
          title: RoutesTitle.flightStatusSearch,
          id: BookingPageId.flightStatusSearch,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.flightStatusRecap,
        loadChildren: () => import('./booking/flight-status-recap/flight-status-recap.module').then((m) => m.FlightStatusRecapModule),
        data: {
          title: RoutesTitle.flightStatusRecap,
          id: BookingPageId.flightStatusRecap,
          entryPoint: true
        }
      },
      {
        path: ManageBookingRoutes.blueRibbonBags,
        loadChildren: () => import('./shared/insurance/index').then((m) => m.InsuranceModule),
        data: {
          title: RoutesTitle.blueRibbonBags,
          id: BookingPageId.blueRibbonBags,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.carRentalInApp,
        loadChildren: () => import('./shared/car-rental-in-app/car-rental-in-app.module').then((c) => c.CarRentalInAppModule),
        data: {
          title: RoutesTitle.carRentalInApp,
          id: BookingPageId.carRentalInApp,
          entryPoint: true
        }
      },
      {
        path: BookingRoutes.insurance,
        loadChildren: () => import('./shared/insurance/index').then((m) => m.InsuranceModule),
        data: {
          title: RoutesTitle.insurance,
          id: BookingPageId.insurance,
          entryPoint: true
        }
      },
      {
        path: '**',
        redirectTo: `/${BookingRoutes.recovery}`,
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled',
      canceledNavigationResolution: 'computed'
    })
  ],
  providers: [AppGuard],
  exports: [RouterModule]
})
export class AppRoutingModule {}
